import { render, staticRenderFns } from "./TemplateDrawer.vue?vue&type=template&id=355b6b4e&scoped=true"
import script from "./TemplateDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemplateDrawer.vue?vue&type=style&index=0&id=355b6b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b6b4e",
  null
  
)

export default component.exports